import { Box, Chip, TextField, makeStyles } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import IconChannel from "../IconChannel";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    minWidth: 0,
    "& .MuiAutocomplete-inputRoot": {
      flexWrap: "nowrap !important",
      overflow: "hidden",
      alignItems: "center",
      maxHeight: 40,
    },
    "& .MuiAutocomplete-tag": {
      maxWidth: "calc(100% - 36px)",
      margin: "1px 2px 1px 0 !important",
    },
    "& .MuiChip-root": {
      height: 20,
      maxWidth: "100%",
    },
    "& .MuiChip-label": {
      paddingLeft: 4,
      paddingRight: 4,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "flex",
      alignItems: "center",
    },
  },
  optionRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: 13,
    minWidth: 0,
    width: "100%",
  },
  optionIcon: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: 18,
    height: 18,
  },
  optionName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  chipLabel: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    maxWidth: "100%",
    overflow: "hidden",
  },
  chipName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: 72,
    fontSize: "0.62rem",
  },
  limitTag: {
    height: 20,
    fontSize: "0.62rem",
    backgroundColor: "rgba(0,0,0,0.08)",
    margin: "1px 0 !important",
  },
}));

const renderConnectionChipLabel = (option, classes) => (
  <span className={classes.chipLabel}>
    <span className={classes.optionIcon}>
      {IconChannel(option.channel, { size: 14 })}
    </span>
    <span className={classes.chipName}>{option.name}</span>
  </span>
);

export function WhatsappsFilter({ onFiltered, initialWhatsapps }) {
  const classes = useStyles();
  const [whatsapps, setWhatsapps] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    async function fetchData() {
      await loadWhatsapps();
    }
    fetchData();
  }, []);

  useEffect(() => {
    setSelecteds([]);
    if (
      Array.isArray(initialWhatsapps) &&
      Array.isArray(whatsapps) &&
      whatsapps.length > 0
    ) {
      onChange(initialWhatsapps);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialWhatsapps, whatsapps]);

  const loadWhatsapps = async () => {
    try {
      const { data } = await api.get(`/whatsapp`);
      const whatsappList = data.map((w) => ({
        id: w.id,
        name: w.name,
        channel: w.channel,
      }));
      setWhatsapps(whatsappList);
    } catch (err) {
      toastError(err);
    }
  };

  const onChange = async (value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  return (
    <Box className={classes.root}>
      <Autocomplete
        multiple
        size="small"
        options={whatsapps}
        value={selecteds}
        onChange={(e, v) => onChange(v)}
        getOptionLabel={(option) => option.name || ""}
        getOptionSelected={(option, value) =>
          option?.id === value?.id ||
          option?.name?.toLowerCase() === value?.name?.toLowerCase()
        }
        renderOption={(option) => (
          <div className={classes.optionRow}>
            <span className={classes.optionIcon}>
              {IconChannel(option.channel, { size: 18 })}
            </span>
            <span className={classes.optionName}>{option.name}</span>
          </div>
        )}
        renderTags={(value, getWhatsappProps) => {
          if (!value.length) return null;

          if (value.length === 1) {
            const option = value[0];
            return [
              <Chip
                key={option.id || option.name}
                variant="outlined"
                style={{
                  backgroundColor: "#bfbfbf",
                  color: "white",
                }}
                label={renderConnectionChipLabel(option, classes)}
                {...getWhatsappProps({ index: 0 })}
                size="small"
              />,
            ];
          }

          return [
            <Chip
              key="connections-summary"
              className={classes.limitTag}
              size="small"
              label={
                <span className={classes.chipLabel}>
                  <span className={classes.optionIcon}>
                    {IconChannel(value[0].channel, { size: 14 })}
                  </span>
                  <span className={classes.chipName}>
                    {value.length} conexões
                  </span>
                </span>
              }
              onDelete={() => onChange([])}
            />,
          ];
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={selecteds.length ? "" : "Conexão"}
          />
        )}
      />
    </Box>
  );
}
